/**
 * --------------------------------------------------
 * components/ClipboardCopyButton.ts
 * ClipboardCopyButton
 * --------------------------------------------------
*/

import { Component, Ref, Prop} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Url } from 'url';

@Component
export class ClipboardCopyButton extends ThemeComponent {
    @Prop({default: null}) copy!: string;
    @Ref copyButton!: HTMLElement;
    @Ref alert!: HTMLElement;

    private copyText:string = this.copy;

    init() {
        if (!this.copyText) {
            this.copyText = window.location.href;
        }
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {
        this.copyButton.addEventListener('click', () => {
            this.copyToClipboard();
        });
    }

    /**
     * Handle copy tp clipboard
     */
    copyToClipboard() {
        navigator.clipboard.writeText(this.copyText).then(() => {
            this.$log.info('Copied successfully!');
            this.alert.classList.add('is-active');

            setTimeout(()=> {
                this.alert.classList.remove('is-active');
            }, 3000);
        }, (err) => {
            this.$log.info('Failed to copy', err);
        });
    }
}
